
import { useLocation } from "react-router-dom";


const ObjectiveQuestionPaper = ({ element, currentQuestion, handleRadioChange, setAnswerData }) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const exam_email = searchParams.get("exam_email");
    const freelancerID = searchParams.get("freelancerID");
    const exam_course = searchParams.get("exam_course");
    const handelObjective = async (e) => {
        // console.log(e.target.value);
        const answerData = {
            questions: currentQuestion.Questions,
            submit_answer: e.target.value ? e.target.value : '' || currentQuestion.selectedOption || "", // Assuming selectedOption is the answer
            email: exam_email,
            freelancerID: freelancerID,
            exam_course: exam_course,
            empid: currentQuestion.queid
        };
        // console.log(answerData);
        setAnswerData(answerData);

    }

    // console.log(currentQuestion    );


    return (
        <div>
            <form onChange={handelObjective}>
                <div className="flex items-center gap-3 ">
                    <input className="radio radio-primary" type="radio" name="radio" id="objective1"
                        checked={currentQuestion.selectedOption === "A"}
                        onChange={(event) => {
                            handleRadioChange("A");
                            // inputEvent(event);
                        }}
                        value={element.OptionA}
                    />
                    <label htmlFor="objective1">
                        <div className="label cursor-pointer ">
                            <span className="">{element.OptionA}</span>
                        </div>
                    </label>
                </div>
                <div className="flex items-center gap-3 ">
                    <input className="radio radio-primary" type="radio" name="radio" id="objective2"
                        checked={currentQuestion.selectedOption === "B"}
                        onChange={(event) => {
                            handleRadioChange("B");
                            // inputEvent(event);
                        }}
                        value={element.OptionB}
                    />
                    <label htmlFor="objective2">
                        <div className="label cursor-pointer">
                            <span className="">{element.OptionB}</span>
                        </div>
                    </label>
                </div>
                <div className="flex items-center gap-3 ">
                    <input className="radio radio-primary" type="radio" name="radio" id="objective3"
                        checked={currentQuestion.selectedOption === "C"}
                        onChange={(event) => {
                            handleRadioChange("C");
                            // inputEvent(event);
                        }}
                        value={element.OptionC}
                    />
                    <label htmlFor="objective3">
                        <div className="label cursor-pointer">
                            <span className="">{element.OptionC}</span>
                        </div>
                    </label>
                </div>
                <div className="flex items-center gap-3 ">
                    <input className="radio radio-primary" type="radio" name="radio" id="objective4"
                        checked={currentQuestion.selectedOption === "D"}
                        onChange={(event) => {
                            handleRadioChange("D");
                            // inputEvent(event);
                        }}
                        value={element.OptionD}
                    />
                    <label htmlFor="objective4">
                        <div className="label cursor-pointer">
                            <span className="">{element.OptionD}</span>
                        </div>
                    </label>
                </div>
            </form>
        </div>
    );
};

export default ObjectiveQuestionPaper;